<template>
  <div class="data-table card">
    <div class="card-header">
      <div class="card-header-title" v-if="title" :style="titleStyle?titleStyle:''">
        <span v-if="totalItems > 1">{{ totalItems }}&nbsp;</span>
        <span style="text-transform: capitalize">{{ title }}</span>
      </div>
    </div>
    <div class="card-content">
      <table class="table is-fullwidth is-striped is-bordered is-hoverable" v-if="count > 0" style="position:relative">
        <thead>
          <tr>
            <th id="data-table-header" v-for="(key, index) in labels" :key="key" 
              :class="{'key': key===rowKey, 'ordered': orderingLabels.indexOf(key) > -1, 'asc': orderby==keys[index], 'desc': orderby=='-'+keys[index]}"
              @click="orderingLabels.indexOf(key) > -1 ? orderby=(orderby==keys[index] ? '-'+keys[index]:keys[index]) : ''"
              :title="definitions[keys[index]]"
            >
              <span v-label>{{ key }}</span>
            </th>
            <th v-show="hasActions"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="object" v-for="object in objects" :key="object.id">
            <data-table-cell
              v-for="key in keys"
              :key="key"
              :objectKey="rowKey"
              :url="url"
              :field-name="key"
              :field-value="object[key]"
              :mappers="mappers"
              :tooltip="tooltips ? object[tooltips[key]] : undefined"
              :editable="editables? editables[key] : false"
              :isModal="modalFields && modalFields.indexOf(key)>-1"
              :expand="expand && expand.indexOf(key)>-1"
              :editUrl="editUrl"
              :keyField="object[rowKey]"
              @modal="$emit('modal', object)"
              @expand="$emit('expand', object)"
            >
              <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
                <slot :name="slot" v-bind:obj="scope.obj"/>
              </template>
            </data-table-cell>
            <td v-show="hasActions" class="nowrap">
              <slot actions :object="object"></slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="count == 0" class="card-content has-text-centered">No data available</div>
  </div>
</template>

<script>
import DataTableCell from '@/components/DataTableCell'
import definitions from '@/assets/variables/tableDefinitions'

export default {
  name: 'data-table',
  props: ['title', 'schema', 'objects', 'objectKey', 'url', 'fields', 'exclude', 'mappers', 'tooltips',
    'alias', 'totalItems', 'titleStyle', 'expand', 'editables', 'editUrl', 'ordering', 'modalFields'],
  components: {DataTableCell},
  data () {
    return {
      orderby: '',
      definitions
    }
  },
  watch: {
    orderby (newVal) {
      this.$emit('order', newVal)
    }
  },
  computed: {
    count () {
      if (!this.objects) {
        return 0
      }
      if (typeof (this.objects) === 'object') {
        return Object.keys(this.objects).length
      }
      if (this.objects.isArray) {
        return this.objects.length
      }
      return 0
    },
    labels () {
      let schema = this.fields ? this.fields : Object.keys(this.schema)
      let labels = []
      schema.forEach(field => {
        if (field === this.rowKey) {
          labels.push('#')
          return
        }
        if (this.alias && this.alias[field]) {
          labels.push(this.alias[field])
          return
        }
        if (!this.exclude || this.exclude.indexOf(field) < 0) {
          labels.push(field)
        }
      })
      return labels
    },
    orderingLabels () {
      let schema = this.ordering ? this.ordering : []
      let labels = []
      schema.forEach(field => {
        if (field === this.rowKey) {
          labels.push('#')
          return
        }
        if (this.alias && this.alias[field]) {
          labels.push(this.alias[field])
          return
        }
        if (!this.exclude || this.exclude.indexOf(field) < 0) {
          labels.push(field)
        }
      })
      return labels
    },
    keys () {
      let schema = this.fields ? this.fields : Object.keys(this.schema)
      let fields = []
      schema.forEach(field => {
        if (!this.exclude || this.exclude.indexOf(field) < 0) {
          fields.push(field)
        }
      })
      return fields
    },
    rowKey () {
      if (!this.objectKey) { return 'id' }
      return this.objectKey
    },
    hasActions () {
      return this.$scopedSlots && this.$scopedSlots['default']
    }
  },
  directives: {
    label: {
      bind (el) { el.textContent = el.textContent.replace(/_/g, ' ') }
    }
  },
  methods: {
    getSlotName (slot) {
      return 'slot-' + slot
    }
  }
}
</script>

<style lang="scss">
  .card{
    height: auto;
    margin-right: 20px;
  }
  .card-header-title{
    font-size: 16px;
    font-weight: 400;
  }
  th.key, td.key{
    text-align: center;
    width: 1px;
    a{
      display: block;
      text-align: center;
    }
  }
  th{
    position: sticky;
    background: white;
  }
  .table, .table thead th{
    border-top: none;
  }
  .data-table .card-content{
    padding: 0;
  }
  .card-content {
    max-height: 60vh;
    max-width: 100%;
    overflow: auto;
  }
  .data-table {
    width: 100%;
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
  }
  .ordered {
    cursor: pointer;
    &.asc {
      &::after{
        content: "\25BC";
      }
    }
    &.desc {
      &::after {
        content: "\25b2";
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/DataTable.vue